import React, { useState, useEffect , useContext} from 'react';
import './Report.css';
import { useNavigate } from 'react-router-dom';
import Url from '../Url';
import { LoginContext } from '../Login/LoginContext';

export default function Reportview() {
    const navigate = useNavigate();
    const [reports, setReports] = useState([]);
    const { loginResult } = useContext(LoginContext);
   const user_id = loginResult.user_id;
    useEffect(() => {
        const fetchReports = async () => {
            try {
                const params = JSON.stringify({ report_id: 49, user_id: user_id,});
                const apiUrl = `${Url.Url}/get_report?data=${encodeURIComponent(params)}`;
                const response = await fetch(apiUrl);
                const data = await response.json();
                setReports(data); // <-- Extract only the array of reports
            } catch (error) {
                console.error("Failed to fetch reports:", error);
            }
        };

        fetchReports();
    }, []);


    const handleNavigation = (link, report_id, title) => {

        navigate('/Sidebar/Reportable', { state: { report_id, title, user_id } });
        console.log('Navigating to:', link, 'with report_id:', report_id,user_id);
    };

    return (
        <section className="report_container_boxes">
            {reports.map((report, index) => (
                <div className="report-card" key={index}>
                    <div className="report-header">
                        <h3>{report.title}</h3>
                    </div>
                    <p>{report.description}</p>
                    <button
                        onClick={() => handleNavigation(report.link, report.report_id, report.title)}
                        className="proceed-button"
                    >
                        PROCEED <i className="fa fa-arrow-right"></i>
                    </button>
                </div>
            ))}
        </section>
    );
}
